import React from 'react';
import RowEditor from './RowEditor';

const ConfigPanel = ({
  sellerName,
  ico,
  dic,
  address,
  saleDate,
  rowCount,
  receiptCount,
  columnsCount,
  scale,
  showBorders,
  showCuttingLines,
  showRowEditor,
  rowsData,
  onSellerNameChange,
  onIcoChange,
  onDicChange,
  onAddressChange,
  onSaleDateChange,
  onRowCountChange,
  onReceiptCountChange,
  onColumnsCountChange,
  onScaleChange,
  onShowBordersChange,
  onShowCuttingLinesChange,
  onToggleRowEditor,
  onRowChange,
  onPrint
}) => (
  <div className="config-panel">
    <h2>Nastavení účtenek</h2>
    <div className="form-group">
      <label>Prodejce:</label>
      <input
        type="text"
        value={sellerName}
        onChange={(event) => onSellerNameChange(event.target.value)}
        placeholder="Jméno nebo firma"
      />
    </div>
    <div className="form-group">
      <label>IČO:</label>
      <input
        type="text"
        value={ico}
        onChange={(event) => onIcoChange(event.target.value)}
        placeholder="IČO"
      />
    </div>
    <div className="form-group">
      <label>DIČ:</label>
      <input
        type="text"
        value={dic}
        onChange={(event) => onDicChange(event.target.value)}
        placeholder="DIČ (pro plátce DPH)"
      />
    </div>
    <div className="form-group">
      <label>Adresa:</label>
      <input
        type="text"
        value={address}
        onChange={(event) => onAddressChange(event.target.value)}
        placeholder="Ulice, město, PSČ (nepovinné)"
      />
    </div>
    <div className="form-group">
      <label>Datum prodeje:</label>
      <input
        type="text"
        value={saleDate}
        onChange={(event) => onSaleDateChange(event.target.value)}
        placeholder="Např. 8. 7. nebo červenec 2026"
      />
    </div>
    <div className="form-group">
      <label>Počet řádků v tabulce:</label>
      <select value={rowCount} onChange={onRowCountChange}>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
      </select>
    </div>
    <div className="form-group">
      <label>Počet účtenek na stránce:</label>
      <select value={receiptCount} onChange={(event) => onReceiptCountChange(parseInt(event.target.value, 10))}>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="4">4</option>
        <option value="6">6</option>
        <option value="8">8</option>
        <option value="10">10</option>
        <option value="12">12</option>
        <option value="14">14</option>
      </select>
    </div>
    <div className="form-group">
      <label>Počet sloupců:</label>
      <select value={columnsCount} onChange={(event) => onColumnsCountChange(parseInt(event.target.value, 10))}>
        <option value="1">1</option>
        <option value="2">2</option>
      </select>
    </div>
    <div className="form-group">
      <label>Velikost zobrazení na obrazovce:</label>
      <input
        type="range"
        min="0.5"
        max="2"
        step="0.1"
        value={scale}
        onChange={onScaleChange}
      />
      <span>{Math.round(scale * 100)}%</span>
    </div>

    <div className="form-group checkbox-group">
      <label>
        <input
          type="checkbox"
          checked={showBorders}
          onChange={(event) => onShowBordersChange(event.target.checked)}
        />
        Zobrazit ohraničení účtenek
      </label>
    </div>

    <div className="form-group checkbox-group">
      <label>
        <input
          type="checkbox"
          checked={showCuttingLines}
          onChange={(event) => onShowCuttingLinesChange(event.target.checked)}
        />
        Zobrazit dělicí čáry
      </label>
    </div>

    <div className="form-group">
      <button
        className="secondary-button"
        onClick={onToggleRowEditor}
      >
        {showRowEditor ? "Skrýt editor řádků" : "Předvyplnit položky"}
      </button>
    </div>

    {showRowEditor && (
      <RowEditor
        rowsData={rowsData}
        rowCount={rowCount}
        onRowChange={onRowChange}
      />
    )}

    <button className="print-button" onClick={onPrint}>Vytisknout</button>
    <div className="info-box">
      <h3>Informace</h3>
      <p>Tato aplikace umožňuje vytvářet a tisknout účtenky pro prodej zboží.</p>
      <p>Můžete zvolit počet sloupců a zobrazení dělicích čar pro snadné oddělení účtenek.</p>
      <p>Pro předvyplnění položek klikněte na tlačítko "Předvyplnit položky".</p>
    </div>
  </div>
);

export default ConfigPanel;
